module.exports = __webpack_public_path__ + "img/FR15448.87b846c9.png";